
/** Must match `server/ground.py`'s `PICKUP_RANGE_MM`. */
export const REACH_MM = 3_000;

export interface LootCandidate {
  readonly id: number;
  readonly kind: number;
  readonly xMm: number;
  readonly yMm: number;
}

/** `EntityKind.ITEM`. Duplicated from the connection to keep this dependency-free. */
const ITEM_KIND = 4;

export function isLoot(entity: { readonly kind: number }): boolean {
  return entity.kind === ITEM_KIND;
}

export function nearestLoot(
  candidates: readonly LootCandidate[],
  xMm: number,
  yMm: number,
  reachMm: number = REACH_MM,
): number | null {
  let best: number | null = null;
  let bestDistance = reachMm * reachMm;

  for (const candidate of candidates) {
    if (!isLoot(candidate)) continue;
    const dx = candidate.xMm - xMm;
    const dy = candidate.yMm - yMm;
    const distance = dx * dx + dy * dy;
    if (distance > bestDistance) continue;
    if (distance === bestDistance && best !== null && candidate.id >= best) continue;
    best = candidate.id;
    bestDistance = distance;
  }

  return best;
}
